import { isValidUrl } from '@/modules/Avatar/utils';

export function isLikelyUrl(value: string): boolean {
  if (!value) return false;
  if (value.startsWith('data:') || value.startsWith('blob:')) {
    return true;
  }
  return isValidUrl(value);
}
